import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {Button} from 'react-bootstrap';
import * as actions from '../../_redux/invoicesActions';
import {Modal} from 'react-bootstrap';
import {Formik} from 'formik';
import {Form} from 'formik';
import can from '../../../_common/components/Permissions/can';
import DataItemCheckbox from "../../../_common/components/DataItemCheckbox";

const PopupSendReminder = ({cellContent}) => {
  const {formatMessage} = useIntl();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const dispatch = useDispatch();
  const isEnabled = cellContent?.status === 1 && can('full', 'invoices');
  const buttonClassName = `w-100 px-4 py-2 d-flex align-items-center justify-content-between text-nowrap font-size-lg 
  ${isEnabled ? `` : `opacity-30`}`;
  const checkboxClassnames = 'd-flex justify-content-between align-items-center';

  return (
    <>
      <div
        className={buttonClassName}
        onClick={() => {
          if (isEnabled) handleShowModal();
        }}
      >
        {formatMessage({id: 'invoices-button-sendReminder', defaultMessage: 'Send reminder'})}
        <img
          src={toAbsoluteUrl('/media/svg/Urgent-mail_brandColor.svg')}
          alt="icon" className={'w-30px h-30px ml-2'}
        />
      </div>
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Body>
          <Formik
            initialValues={{
              sendByMail: false,
              sendBySMS: false,
              sendByWhatsapp: false,
              sendToAgent: false,
              sendToCustomer: false,
            }}
            onSubmit={() => {
            }}
            enableReinitialize={false}
            validateOnChange={true}
            validateOnBlur={false}
          >
            {({values}) => (
              <Form>
                <div className={'d-flex flex-column align-items-center'}>
                  <h3 className="card-title font-weight-bold text-dark mb-4 mt-0">
                    {formatMessage({id: 'invoices-sendReminder-headerHow', defaultMessage: 'Send reminder'})}
                  </h3>
                  <div className="w-100 d-flex mb-4 justify-content-between">
                    <DataItemCheckbox
                      fieldName={'sendByMail'}
                      label={formatMessage({id: 'invoices-sendReminder-mail', defaultMessage: 'Send reminder via mail'})}
                      containerClassname={checkboxClassnames}
                      containerStyles={{direction: 'ltr'}}
                    />
                    <DataItemCheckbox
                      fieldName={'sendBySMS'}
                      label={formatMessage({id: 'invoices-sendReminder-sms', defaultMessage: 'Send reminder via sms'})}
                      containerClassname={checkboxClassnames}
                      containerStyles={{direction: 'ltr'}}
                    />
                    <DataItemCheckbox
                      fieldName={'sendByWhatsapp'}
                      label={formatMessage({id: 'invoices-sendReminder-whatsapp', defaultMessage: 'Send reminder via WhatsApp'})}
                      containerClassname={checkboxClassnames}
                      containerStyles={{direction: 'ltr'}}
                    />
                  </div>
                  <h3 className="card-title font-weight-bold text-dark mb-4 mt-0">
                    {formatMessage({id: 'invoices-sendReminder-headerWho', defaultMessage: 'Send reminder'})}
                  </h3>
                  <div className="d-flex justify-content-evenly mb-8">
                    <DataItemCheckbox
                      fieldName={'sendToAgent'}
                      label={formatMessage({id: 'invoices-sendReminder-agent', defaultMessage: 'Send reminder agent'})}
                      containerClassname={`${checkboxClassnames} mx-4`}
                      containerStyles={{direction: 'ltr'}}
                    />
                    <DataItemCheckbox
                      fieldName={'sendToCustomer'}
                      label={formatMessage({id: 'invoices-sendReminder-customer', defaultMessage: 'Send reminder customer'})}
                      containerClassname={`${checkboxClassnames} mx-4`}
                      containerStyles={{direction: 'ltr'}}
                    />
                  </div>
                  <div className="d-flex justify-content-center">
                    <Button className="btn-secondary mx-3 btn-sm w-100px" onClick={handleCloseModal}>
                      {formatMessage({id: 'invoices-popup-buttonCancel', defaultMessage: 'Cancel'})}
                    </Button>
                    <Button
                      className="btn-sm mx-3 custom-send-button w-100px"
                      disabled={!(
                        (values.sendToAgent || values.sendToCustomer) &&
                        (values.sendByMail || values.sendBySMS || values.sendByWhatsapp)
                      )}
                      onClick={() => {
                        dispatch(actions.sendInvoiceReminderAction({
                          invoiceID: cellContent?._id,
                          sendToAgent: values.sendToAgent,
                          sendToCustomer: values.sendToCustomer,
                          sendByMail: values.sendByMail,
                          sendBySMS: values.sendBySMS,
                          sendByWhatsapp: values.sendByWhatsapp,
                          agentID: cellContent?.agentId,
                          customerID: cellContent?.customerID,
                        }));
                        handleCloseModal();
                      }}
                    >
                      {formatMessage({id: 'invoices-popup-buttonSend', defaultMessage: 'Send'})}
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupSendReminder;